import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from '../auth/ProtectedRoute'
import { TenantsPage } from '../pages/TenantsPage'
import { TenantRequestsPage } from '../pages/TenantRequestsPage'
import { CallbackPage } from '../pages/CallbackPage'
import { SignoutCallbackPage } from '../pages/SignoutCallbackPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { InternalAccessPage } from '../pages/InternalAccessPage'
import { AnnouncementsPage } from '../features/announcements/pages/AnnouncementsPage'
import { SurveysPage } from '../features/surveys/pages/SurveysPage'
import { BillingPage } from '../features/billing/pages/BillingPage'
import { TerminationRequestsPage } from '../features/workspace-terminations/pages/TerminationRequestsPage'
import { useAuth } from '../auth/AuthContext'
import { hasBillingAccess, canViewTerminations, canAccessRequests, canViewWorkspaces } from '../utils/roles'

export function AppRoutes() {
  const { user } = useAuth()

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            {canAccessRequests(user) ? <TenantRequestsPage /> : <Navigate to="/workspaces" replace />}
          </ProtectedRoute>
        }
      />
      {canAccessRequests(user) && (
        <Route
          path="/requests"
          element={
            <ProtectedRoute>
              <TenantRequestsPage />
            </ProtectedRoute>
          }
        />
      )}
      {(!user || canViewWorkspaces(user)) && (
        <Route
          path="/workspaces"
          element={
            <ProtectedRoute>
              <TenantsPage />
            </ProtectedRoute>
          }
        />
      )}
      <Route
        path="/internal-access"
        element={
          <ProtectedRoute>
            <InternalAccessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/announcements"
        element={
          <ProtectedRoute>
            <AnnouncementsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/surveys"
        element={
          <ProtectedRoute>
            <SurveysPage />
          </ProtectedRoute>
        }
      />
      {hasBillingAccess(user) && (
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <BillingPage />
            </ProtectedRoute>
          }
        />
      )}
      {canViewTerminations(user) && (
        <Route
          path="/terminations"
          element={
            <ProtectedRoute>
              <TerminationRequestsPage />
            </ProtectedRoute>
          }
        />
      )}
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/signout-callback" element={<SignoutCallbackPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
